export default __webpack_public_path__ + "static/media/stx.0279fff2.svg";